export default __webpack_public_path__ + "static/media/1.77c31de9.png";